import { render } from "./CitaNueva.vue?vue&type=template&id=b808659a&scoped=true&ts=true"
import script from "./CitaNueva.vue?vue&type=script&lang=ts"
export * from "./CitaNueva.vue?vue&type=script&lang=ts"

import "./CitaNueva.vue?vue&type=style&index=0&id=b808659a&lang=scss&scoped=true"

import exportComponent from "/home/rdimicheleb/Repos/AMII/apps/app-paciente/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b808659a"]])

export default __exports__